import type { BusinessProfileDraft } from '@mouja/domain/analysis';

/** Facts the merchant must establish before the exact profile can be approved. */
export function missingProfileConfirmationFields(
  profile: BusinessProfileDraft,
): readonly string[] {
  return [
    profile.identity.value?.trim() ? null : 'your business name',
    profile.niche.value?.trim() ? null : 'what your business does',
    profile.geography.value?.trim() ? null : 'where your business operates',
    profile.offers.some((offer) => offer.title.value?.trim())
      ? null
      : 'at least one concrete offer',
  ].filter((entry): entry is string => entry !== null);
}
